import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const WS_BASE_URL = API_BASE_URL.replace('http', 'ws');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const chatService = {
  // Get chat history
  getChatHistory: async (limit = 50, skip = 0) => {
    try {
      const response = await api.get(`/api/chat/messages?limit=${limit}&skip=${skip}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching chat history:', error);
      return { success: false, error: 'Failed to load chat history', data: [] };
    }
  },
  
  // Delete a chat message (admin only)
  deleteMessage: async (messageId) => {
    try {
      const response = await api.delete(`/api/chat/messages/${messageId}`);
      return { success: true, message: response.data.message };
    } catch (error) {
      console.error('Error deleting message:', error);
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Failed to delete message' 
      };
    }
  },
  
  // Get WebSocket URL
  getWebSocketUrl: () => {
    const token = localStorage.getItem('access_token');
    return `${WS_BASE_URL}/api/chat/ws?token=${token}`;
  }
};

export default chatService;

